import { GetterTree } from 'vuex'
import { IAuthState, IRootState } from '@/@types'

const getters: GetterTree<IAuthState, IRootState> = {
  isBusinessUser: state => {
    if (state.userProfile) {
      const { account_id } = state.userProfile
      return !!account_id
    }
    return false
  },

  canManageMFA: state => {
    if (state.userProfile) {
      const { mfa_required } = state.userProfile
      if (mfa_required && mfa_required === 1) {
        return false
      }
    }
    return true
  },

  hasPlaylists: state => state.hasPlaylists,

  isFreeTrialUser: state => {
    if (state.subscriptionStatus && state.subscriptionStatus.length) {
      return state.subscriptionStatus === 'free'
    }
    return false
  },
  isBusinessManager: state => {
    return state.isBusinessManager
  },
}

export default getters
